<template>
  <div class="container">
    <div class="information-left" v-if="!isUSTWall && !isSimple" :class="{'information-left-curved':isCurved}">
      <div id="copy_text">
        <ul v-if="position === 0 && ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0))">
          <li v-if=!isCurved class="projector_text result_brightnessguide-position-title">
            <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
          </li>
          <li>
            <!-- =SimPH -->
            (1) {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')}}{{floor2Projector + ' ' +unitLableText}}
          </li>
          <li>
            <!-- =TH -->
            (2) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLableText}}
          </li>
          <li>
            <!-- =RH-(SH+SB) -->
            (3) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
          </li>
          <li>
            <!-- =SB -->
            (4) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
          </li>
          <li>
            <!-- =SW,=SH -->
            (5) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
          </li>
          <li>
            <!-- =SD -->
            (6) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
          </li>
          <li>
            <!-- =Angle (Vertical) -->
            (7) {{$t('T_RESULT_PROJECTOR_ANGLE_V')}}{{vAngleData}}
          </li>
          <li>
            <!-- =Angle (Rotation && Horizontal) -->
            (8) {{$t('T_RESULT_PROJECTOR_ANGLE_R_KEYSTONE')}}{{hAngleData}}
          </li>
        </ul>
        <ul v-else-if="position === 0 && this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1">
          <li v-if=!isCurved class="projector_text result_brightnessguide-position-title">
            <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
          </li>
          <li>
            <!-- =SimPH-FE -->
            (1) {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')}}<span :class="isNegativeNum ? 'negative_num_color' : ''">{{floor2footProjector}}</span>
          </li>
          <li>
            <!-- =ABS((SimPH-FE)-SB) -->
            (2) {{$t('T_RESULT_BOTTOM_OF_SCREEN_TO_FOOT_OF_PROJECTOR_HEIGHT')}}{{bottom2FootProjector}}
          </li>
          <li>
            <!-- =TH -->
            (3) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLableText}}
          </li>
          <li>
            <!-- =TH-LX -->
            (4) {{$t('T_RESULT_SCREEN_TO_PROJECTOR')}}{{screen2projector}}
          </li>
          <li>
            <!-- =RH-(SH+SB) -->
            (5) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
          </li>
          <li>
            <!-- =SB -->
            (6) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
          </li>
          <li>
            <!-- =SW,=SH -->
            (7) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
          </li>
          <li>
            <!-- =SD -->
            (8) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
          </li>
        </ul>
        <ul v-else v-show="position === 0 ? true : false">
          <li v-if=!isCurved class="projector_text result_brightnessguide-position-title">
            <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
          </li>
          <li>
            <!-- =SimPH-FE -->
            (1) {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')}}<span :class="isNegativeNum ? 'negative_num_color' : ''">{{floor2footProjector}}</span>
          </li>
          <li>
            <!-- =ABS((SimPH-FE)-SB) -->
            (2) {{$t('T_RESULT_BOTTOM_OF_SCREEN_TO_FOOT_OF_PROJECTOR_HEIGHT')}}{{bottom2FootProjector}}
          </li>
          <li>
            <!-- =TH -->
            (3) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLableText}}
          </li>
          <li>
            <!-- =RH-(SH+SB) -->
            (4) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
          </li>
          <li>
            <!-- =SB -->
            (5) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
          </li>
          <li>
            <!-- =SW,=SH -->
            (6) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
          </li>
          <li>
            <!-- =SD -->
            (7) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
          </li>
        </ul>
        <ul v-if="position !== 0 && ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0))">
          <li v-if=!isCurved class="projector_text result_brightnessguide-position-title">
            <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
          </li>
          <li>
            <!-- =RH-SimPH -->
            (1) {{$t('T_RESULT_CEILING_TO_LENS')}}{{floor2Projector + ' ' +unitLableText}}
          </li>
          <li>
            <!-- =TH -->
            (2) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLableText}}
          </li>
          <li>
            <!-- =RH-(SH+SB) -->
            (3) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
          </li>
          <li>
            <!-- =SB -->
            (4) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
          </li>
          <li>
            <!-- =SW,=SH -->
            (5) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
          </li>
          <li>
            <!-- =SD -->
            (6) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
          </li>
          <li>
            <!-- =Angle (Vertical) -->
            (7) {{$t('T_RESULT_PROJECTOR_ANGLE_V_KEYSTONE')}}{{vAngleData}}
          </li>
          <li>
            <!-- =Angle (Rotation && Horizontal) -->
            (8) {{$t('T_RESULT_PROJECTOR_ANGLE_R_KEYSTONE')}}{{hAngleData}}
          </li>
        </ul>
        <ul v-else-if="position !== 0 && this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1">
          <li v-if=!isCurved class="projector_text result_brightnessguide-position-title">
            <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
          </li>
          <li>
            <!-- =RH-(SimPH+CC+MU) -->
            (1) {{$t('T_RESULT_CEILING_TO_BOTTOM_HEIGHT')}}{{ceiling2topLx}}
          </li>
          <li>
            <!-- =ABS((SimPH+CC+MU)-(SH+SB)) -->
            (2) {{$t('T_RESULT_SCREEN_TO_BOTTOM_HEIGHT')}}{{top2bottomProjectorLx}}
          </li>
          <li>
            <!-- =SimPH+CC-UP -->
            (3) {{$t('T_RESULT_FLOOR_TO_UPPER_HEIGHT')}}{{floor2upperProjectorLx}}
          </li>
          <li>
            <!-- =TH -->
            (4) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLableText}}
          </li>
          <li>
            <!-- =TH-LX -->
            (5) {{$t('T_RESULT_SCREEN_TO_PROJECTOR_DISTANCE')}}{{screen2projector}}
          </li>
          <li>
            <!-- =RH-(SH+SB) -->
            (6) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
          </li>
          <li>
            <!-- =SB -->
            (7) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
          </li>
          <li>
            <!-- =SW,=SH -->
            (8) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
          </li>
          <li>
            <!-- =SD -->
            (9) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
          </li>
        </ul>
        <ul v-else v-show="position !== 0 ? true : false">
          <li v-if=!isCurved class="projector_text result_brightnessguide-position-title">
            <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
          </li>
          <li>
            <!-- =RH-(SimPH+MU) -->
            (1) {{$t('T_RESULT_CEILING_TO_BOTTOM_HEIGHT')}}{{ceiling2top}}
          </li>
          <li>
            <!-- =ABS((SimPH+MU)-(SH+SB)) -->
            (2) {{$t('T_RESULT_SCREEN_TO_BOTTOM_HEIGHT')}}{{top2bottomProjector}}
          </li>
          <li>
            <!-- =SimPH-UP -->
            (3) {{$t('T_RESULT_FLOOR_TO_UPPER_HEIGHT')}}{{floor2upperProjector}}
          </li>
          <li>
            <!-- =TH -->
            (4) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLableText}}
          </li>
          <li>
            <!-- =RH-(SH+SB) -->
            (5) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
          </li>
          <li>
            <!-- =SB -->
            (6) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
          </li>
          <li>
            <!-- =SW,=SH -->
            (7) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
          </li>
          <li>
            <!-- =SD -->
            (8) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
          </li>
        </ul>
        <div class="projector_setting">
          <ul>
            <li v-if=!isCurved class="projector_text result_brightnessguide-setting-title">
              <span>{{$t('T_RESULT_PROJECTOR_SETTING')}}</span>
            </li>
            <li :class="{'vlensshift-curved': isCurved}">
              {{$t('T_RESULT_LENS_SHIFT_V')}}{{vLensShiftNowData}}
            </li>
            <li>
              {{$t('T_RESULT_LENS_SHIFT_H')}}{{hLensShiftNowData}}
            </li>
            <div v-if="!isCurved">
              <li v-show="keyStoneFlag">
                {{$t('T_RESULT_KEYSTONE_CORRECTION_V')}}{{$t(keyStoneVerticalShow)}}
              </li>
              <li v-show="keyStoneFlag">
                {{$t('T_RESULT_KEYSTONE_CORRECTION_H')}}{{$t(keyStoneHorizontalShow)}}
              </li>
              <li v-show="quickCornerFlag">
                {{$t('T_RESULT_QUICKCORNER_CORRECTION')}}{{$t(cornerAreasShow)}}
              </li>
            </div>

            <!-- <li>
              {{$t('T_CURVED_SURFACE_CORRECTION')}}TBD
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="information-right" v-if="!isUSTWall && !isSimple" :class="[classValue(), {'information-right-curved':isCurved}]"></div>
  </div>
</template>

<script>
import resultReport from '@/view/result/resultReport'
import resultInformationButton from '@/view/result/resultInformationButton'
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'resultInformation',
  data () {
    return {
      dialogVisible: false,
      reportTopTableInfo: [],
      projectorPosition: [],
      projectorSetting: [],
      relativeBasePointer: '',
      UstResultImg: '',
      SimpleResultImg: '',
      isNegativeNum: false
    }
  },
  props: ['isCurved'],
  methods: {
    ...mapMutations([
      'SET_SHOWINPUTFLAG', 'SET_TEXTDATA', 'SET_KEYSTONEVERTICAL', 'SET_KEYSTONEHORIZONTAL', 'SET_SETTINGACTIVE', 'SET_FONTSIZE', 'SET_DISABLEDNONE',
      'SET_SCREENSIZEACTIVE', 'SET_THROWACTIVE'
    ]),

    getRelativeBasePointer (value) {
      this.$nextTick(() => {
        let screenPointer0 = this.drawData[0][0] || {}
        return 'X: ' + this.$commonJs.changeUnit(value.pjX - screenPointer0.x, this.graph.unit) + this.unitLableText + ', Y: ' + this.$commonJs.changeUnit(value.pjY, this.graph.unit) + this.unitLableText + ', Z: ' + this.$commonJs.changeUnit(value.pjZ - screenPointer0.z, this.graph.unit) + this.unitLableText
      })
    },

    classValue () {
      if (this.position === 0) {
        if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
          if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
            return 'information-right-desk-lx-angle'
          } else {
            return 'information-right-desk-angle'
          }
        } else {
          if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
            return 'information-right-desk-lx'
          } else {
            return 'information-right-desk'
          }
        }
      } else {
        if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
          if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
            return 'information-right-ceil-lx-angle'
          } else {
            return 'information-right-ceil-angle'
          }
        } else {
          if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
            return 'information-right-ceil-lx'
          } else {
            return 'information-right-ceil'
          }
        }
      }
    }
  },

  mounted () {
    this.relativeBasePointer = this.getRelativeBasePointer(this.graph)
  },

  components: {
    resultReport,
    resultInformationButton
  },

  filters: {
    filterKeyStone (value) {
      return value === 1 ? 'Available' : 'Not Available'
    }
  },

  computed: {
    ...mapState([
      'graph',
      'vLensShift',
      'hLensShift',
      'vAngleFlag',
      'vAngle',
      'hAngleFlag',
      'hAngle',
      'selectedModelData',
      'selectedLensData',
      'drawData',
      'houseInfo',
      'vLensShiftNow',
      'hLensShiftNow',
      'floor2bottom',
      'screenSize',
      'position',
      'isUSTWall',
      'dashFlag',
      'isSimple',
      'browserType',
      'SettingActive',
      'setfontSize',
      'screenActive',
      'throwDisActive',
      'indAngleSwitch',
      'isOnCornerAreas',
      'aspectRatio'
    ]),

    ...mapGetters([
      'unitLabel'
    ]),

    pjYData () {
      return this.$commonJs.changeUnit(this.graph.pjY, this.graph.unit)
    },

    unitLableText () {
      if (this.graph.unit === 'T_FEET_FRACTION' || this.graph.unit === 'T_INCH_FRACTION') {
        return ''
      } else {
        return this.unitLabel
      }
    },

    scrnW_H () {
      let scrnW = this.$commonJs.changeUnit(this.graph.scrnW, this.graph.unit)
      let scrnH = this.$commonJs.changeUnit(this.graph.scrnH, this.graph.unit)
      if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
        if (this.dashFlag) {
          return scrnW + ' x ' + scrnH + ' ' + this.unitLableText
        } else {
          return '-'
        }
      } else {
        return scrnW + ' x ' + scrnH + ' ' + this.unitLableText
      }
    },

    floor2Projector () {
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.position === 0) {
        return this.$commonJs.changeUnit(f2l, this.graph.unit)
      } else {
        return this.$commonJs.changeUnit(this.houseInfo.roomH - f2l, this.graph.unit)
      }
    },
    keyStoneVertical () {
      let data = this.vAngleFlag ? this.hAngleFlag ? 0 : this.vAngle >= this.keyStoneRangleV.min && this.vAngle <= this.keyStoneRangleV.max ? 1 : 0 : 1
      this.SET_KEYSTONEVERTICAL(data)
      return data
    },

    keyStoneVerticalShow () {
      return this.keyStoneVertical === 1 ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_KEYSTONE_CORRECTION'
    },

    keyStoneHorizontal () {
      let data = this.hAngleFlag ? this.vAngleFlag ? 0 : this.hAngle >= this.keyStoneRangleH.min && this.hAngle <= this.keyStoneRangleH.max ? 1 : 0 : 1
      this.SET_KEYSTONEHORIZONTAL(data)
      return data
    },

    keyStoneHorizontalShow () {
      return this.keyStoneHorizontal === 1 ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_KEYSTONE_CORRECTION'
    },

    cornerAreasShow () {
      return this.isOnCornerAreas ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_QUICKCORNER_CORRECTION'
    },

    keyStoneRangleV () {
      let data = this.selectedModelData
      return {'min': data.keystoneVMin, 'max': data.keystoneVMax}
    },

    keyStoneRangleH () {
      let data = this.selectedModelData
      return {'min': data.keystoneHMin, 'max': data.keystoneHMax}
    },

    vAngleData () {
      return (this.vAngleFlag ? this.vAngle : 0) + '°'
    },

    hAngleData () {
      return (this.hAngleFlag ? this.hAngle : 0) + '°'
    },

    floor2topCpmuted () {
      if (this.drawData) {
        let textName2 = this.drawData[0][3].z - this.drawData[0][0].z
        let f2top = this.houseInfo.roomH - (this.graph.scrnH + this.floor2bottom) + (this.graph.scrnH - textName2)
        return this.$commonJs.changeUnit(f2top > 0 ? f2top : 0, this.graph.unit) + ' ' + this.unitLableText
      }
      return null
    },

    screen2projector () {
      let BrightnessDataLx = this.getBrightnessLx
      if (this.selectedModelData.lensExchange === true) {
        let s2projector = this.graph.pjY - BrightnessDataLx
        return this.$commonJs.changeUnit(s2projector, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let s2projector = this.graph.pjY - this.selectedLensData.lx
        return this.$commonJs.changeUnit(s2projector, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2upperProjector () {
      let BrightnessDataUp = this.getBrightnessUp
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2upper = f2l - BrightnessDataUp
        return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let f2upper = f2l - this.selectedLensData.up
        return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2upperProjectorLx () {
      let BrightnessDataUp = this.getBrightnessUp
      let BrightnessDataCc = this.getBrightnessCc
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2upperlx = f2l + BrightnessDataCc - BrightnessDataUp
        return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let f2upperlx = f2l + BrightnessDataCc - this.selectedLensData.up
        return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    ceiling2top () {
      let BrightnessDataMu = this.getBrightnessMu
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let c2top = this.houseInfo.roomH - (f2l + BrightnessDataMu)
        return this.$commonJs.changeUnit(c2top > 0 ? c2top : 0, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let c2top = this.houseInfo.roomH - (f2l + this.selectedLensData.mu)
        return this.$commonJs.changeUnit(c2top > 0 ? c2top : 0, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    ceiling2topLx () {
      let BrightnessDataCc = this.getBrightnessCc
      let BrightnessDataMu = this.getBrightnessMu
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let c2toplx = this.houseInfo.roomH - (f2l + BrightnessDataCc + BrightnessDataMu)
        return this.$commonJs.changeUnit(c2toplx > 0 ? c2toplx : 0, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let c2toplx = this.houseInfo.roomH - (f2l + BrightnessDataCc + this.selectedLensData.mu)
        return this.$commonJs.changeUnit(c2toplx > 0 ? c2toplx : 0, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      let f2foot = f2l - this.selectedLensData.fe
      if (this.selectedModelData.lensExchange === true) {
        f2foot = f2l - BrightnessDataFe
      }
      this.isNegativeNum = (f2foot*10).toFixed(0) < 0
      return this.$commonJs.changeUnit(f2foot, this.graph.unit) + ' ' + this.unitLableText
    },

    getBrightnessFe () {
      let brightnessfe
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessfe = this.Brightness.optionLens[i].fe / 10
          }
        }
      }
      return brightnessfe
    },

    getBrightnessCc () {
      let brightnesscc
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnesscc = this.Brightness.optionLens[i].cc / 10
          }
        }
      }
      return brightnesscc
    },

    getBrightnessMu () {
      let brightnessmu
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessmu = this.Brightness.optionLens[i].mu / 10
          }
        }
      }
      return brightnessmu
    },

    getBrightnessUp () {
      let brightnessup
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessup = this.Brightness.optionLens[i].up / 10
          }
        }
      }
      return brightnessup
    },

    getBrightnessLx () {
      let brightnesslx
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnesslx = this.Brightness.optionLens[i].lx / 10
          }
        }
      }
      return brightnesslx
    },

    top2bottomProjector () {
      let BrightnessDataMu = this.getBrightnessMu
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let top2projector = Math.abs((f2l + BrightnessDataMu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projector, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let top2projector = Math.abs((f2l + this.selectedLensData.mu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projector, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    top2bottomProjectorLx () {
      let BrightnessDataMu = this.getBrightnessMu
      let BrightnessDataCc = this.getBrightnessCc
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let top2projectorlx = Math.abs((f2l + BrightnessDataCc + BrightnessDataMu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projectorlx, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let top2projectorlx = Math.abs((f2l + BrightnessDataCc + this.selectedLensData.mu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projectorlx, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    bottom2FootProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let b2footprojector = Math.abs((f2l - BrightnessDataFe) - this.floor2bottom)
        return this.$commonJs.changeUnit(b2footprojector, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let b2footprojector = Math.abs((f2l - this.selectedLensData.fe) - this.floor2bottom)
        return this.$commonJs.changeUnit(b2footprojector, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2bottomCpmuted () {
      return this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit) + ' ' + this.unitLableText
    },

    screenSizeComputed () {
      if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
        if (this.dashFlag) {
          return (this.screenSize * 1).toFixed(2) + ' inch'
        } else {
          return '-'
        }
      } else {
        return (this.screenSize * 1).toFixed(2) + ' inch'
      }
    },

    vLensShiftNowData () {
      return this.graph.vLensShift.max === this.graph.vLensShift.min ? 'N/A' : this.vLensShiftNow.toFixed(0) + '%'
    },

    hLensShiftNowData () {
      return this.graph.hLensShift.max === this.graph.hLensShift.min ? 'N/A' : this.hLensShiftNow.toFixed(0) + '%'
    },
    isEdge () {
      let userAgent = navigator.userAgent
      let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      let isEdge = userAgent.indexOf('Edge') > -1 && !isIE

      return isEdge
    },
    keyStoneFlag () {
      return this.indAngleSwitch && (this.vAngleFlag || this.hAngleFlag)
    },
    quickCornerFlag () {
      return this.indAngleSwitch && this.vAngleFlag && this.hAngleFlag
    }
  },

  watch: {
    graph: {
      handler (newValue, oldValue) {
        this.relativeBasePointer = ''
        this.relativeBasePointer = this.getRelativeBasePointer(newValue)
      },
      deep: true
    },
    dialogVisible (val) {
      if (!val && this.isUSTWall) {
        if (document.getElementById('ustImg')) {
          let $ustImg = document.getElementById('ustImg')
          if (this.browserType === 'other' || this.isEdge) {
            $ustImg.remove()
          } else {
            $ustImg.removeNode(true)
          }
        }
      }
      if (!val && this.isSimple) {
        if (document.getElementById('simpleImg')) {
          let $simpleImg = document.getElementById('simpleImg')
          if (this.browserType === 'other' || this.isEdge) {
            $simpleImg.remove()
          } else {
            $simpleImg.removeNode(true)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  position: relative;
}
.result-infomation {
  width: 810px;
  height: 361px;
  margin-top:10px;
  border: 2px solid #bdbdbd;
  background: #fff;
}

.projector_text span {
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.result-information-button {
  position: absolute;
  bottom: 10px;
  left: 20px;
}
.widthLimit {
  width: 96%;
  line-height: 30px;
  bottom: 18px;
}

.information-left {
  float: left;
  padding-left: 10px;
  width: 400px;
  height: 285px;
  white-space: nowrap;
  overflow: auto;
}
.information-left-curved{
  padding-top: 10px;
  height: 230px !important;
}
.information-left ul li {
  font-size: 14px;
  line-height: 1.2;
}

.information-right {
  position: absolute;
  width: 413px;
  height: 275px;
  background: #e3e3e3;
  float: right;
  margin: 20px;
  right: -35px;
  bottom: -35px;
}
.information-right-curved{
  padding-top: 10px;
  width: 310px;
  margin-right: 40px;
  bottom: -72px;
}
.vlensshift-curved{
  padding-top: 10px;
}
.information-right-desk-lx-angle {
  background: url('../../assets/parts/result/result_desk_lx_angle.jpg') no-repeat;
  background-size: contain;
}

.information-right-desk-angle {
  background: url('../../assets/parts/result/result_desk_angle.jpg') no-repeat;
  background-size: contain;
}

.information-right-desk-lx {
  background: url('../../assets/parts/result/result_desk_lx.jpg') no-repeat;
  background-size: contain;
}

.information-right-desk {
  background: url('../../assets/parts/result/result_desk.jpg') no-repeat;
  background-size: contain;
}

.information-right-ceil {
  background: url('../../assets/parts/result/result_ceil.jpg') no-repeat;
  background-size: contain;
}

.information-right-ceil-lx {
  background: url('../../assets/parts/result/result_ceil_lx.jpg') no-repeat;
  background-size: contain;
}

.information-right-ceil-lx-angle {
  background: url('../../assets/parts/result/result_ceil_lx_angle.jpg') no-repeat;
  background-size: contain;
}

.information-right-ceil-angle {
  background: url('../../assets/parts/result/result_ceil_angle.jpg') no-repeat;
  background-size: contain;
}

.padding-left-18 {
  padding-left: 18px;
}

.projector_setting li{
  list-style: disc;
  margin-left: 21px;
}

.projector_setting .result_brightnessguide-setting-title{
  list-style: none;
  margin-left: 0;
}

.information-right img {
  width: 100%;
  height: auto;
}

.special_width {
  width: auto;
}

.simple-pdf-title {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/view/result/resultInformation.vue